import React from 'react';

type MediaIconProps = {
  width?: number;
  height?: number;
  color?: string;
};

export const MediaIcon = ({
  width = 20,
  height = 20,
  color = '#fff',
}: MediaIconProps) => (
  <svg
    width={width}
    height={height}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.667 5H0v4.166h.008L0 16.666c0 .917.75 1.667 1.667 1.667h15v-1.666h-15V5Zm4.166 7.5H17.5l-2.917-3.75-2.083 2.508L9.583 7.5l-3.75 5Zm12.5-9.167h-6.666L10 1.666H5c-.917 0-1.658.75-1.658 1.667l-.009 10C3.333 14.25 4.083 15 5 15h13.333C19.25 15 20 14.25 20 13.333V5c0-.917-.75-1.667-1.667-1.667Zm0 10H5v-10h4.308L10.975 5h7.358v8.333Z"
      fill={color}
    />
  </svg>
);
